import type {
  CompanyCreditInfoRequestType,
  CompanyCreditInfoResponseType,
} from "@sellar-io/api-v2/types";
import { useQuery } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import {
  apiV2AssertResponse,
  ApiV2QueryOptions,
  apiV2Request,
  getDefaultQueryOptionsV2,
} from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useLegalEntityCompanyCreditInfo = <
  TData = CompanyCreditInfoResponseType,
>(
  params: CompanyCreditInfoRequestType,
  options?: ApiV2QueryOptions<TData>,
) => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useQuery({
    queryKey: [
      user?.uid,
      business?.id,
      ServerStateKeys.LegalEntityCreditLimitInfo,
    ],
    queryFn: () =>
      apiV2Request({
        user,
        business,
        method: "get",
        path: `legal-entity/company/credit-info`,
        params: {
          ...params,
        },
      }).then((data) => apiV2AssertResponse<TData>(data).data),
    ...getDefaultQueryOptionsV2({
      context: { scope: "business", user, business: business },
      options: { ...options },
    }),
  });
};
